<template>
    

            
            <b-row class="photo_book_page_list_group">

                <b-col v-for="(cover) in covers" v-bind:key="cover.id" class="photo_book_page_list_group_item auto md-auto">
                    <photo-book-cover-list-item :url="buildUrl(cover)" :num="cover.pos" :state="cover.state" :isSelected="selectedCoverId === cover.id" @coverSelected="coverSelected(cover.id, cover.state)" @coverAccepted="coverAccepted(cover.id)" @coverRejected="coverRejected(cover.id)"></photo-book-cover-list-item>
                </b-col>
               

            </b-row>



</template>

<script>
import PhotoBookCoverListItem from './PhotoBookCoverListItem';
import { mapGetters, mapActions, mapState } from 'vuex'
import { Modal, BaseAlert } from '@/components'

export default {
    name: "photo-book-cover-list",
    components: {
        Modal,
        BaseAlert,
        PhotoBookCoverListItem,
    },
    props: {
        photoBookId: 0,
        token: String,
        fetchCovers: Number,
    },
    data() {
        return {
            loading: false,
            covers: [],
            selectedCoverId: null,
        };
    },
    methods: {
        buildUrl(cover){
            console.log(this.$image_host+cover);
            let ht = this.$image_host+cover.image.medium.url;
            return ht
        },
        coverSelected(page, state){
            this.selectedCoverId = page;
            console.log("SELECTED Cover"+page);
            console.log("SELECTED State"+state);
            this.$emit('coverSelected', page, state);
        },
        coverAccepted(id){
            console.log("Accepted Cover --> "+id);
            this.$emit('coverAccepted', id);
           // this.fetchCoverLayouts();
        },
        coverRejected(id){
            console.log("Rejected Cover --> "+id);
            this.$emit('coverRejected', id);
            this.fetchCoverLayouts();
        },
        fetchCoverLayouts(){
            this.loading = true;
            this.$api.getPhotoBookImages(this.photoBookId, this.id, 'layout_proposal').then((response) => {
                this.covers = response.data.photo_book_images;
                console.log("COVERS HERE");
                console.log(this.covers);
            }).catch((e) => {
                console.log(e);
            }).finally(() => {
                this.loading = false;
            });
        },
    },
    computed: {
        ...mapGetters({
            currentAccount: 'currentAccount',
            currentPhotoBook: 'currentPhotoBook',
           
        }),
    },
    watch: {
        fetchCovers(newValue, oldValue) {
      console.log('queryParameter fetchCovers changed from: ' + oldValue + ' -> ' + newValue);
      //this.change = newValue;
      //this.changeCover();
      this.fetchCoverLayouts();

    },
        },
    
    mounted() {
        //console.log(this.photo_book_id);
        console.log("Loading cover layouts from sererv...");
        this.fetchCoverLayouts();
    },
};
</script>

<style scoped>

.photo_book_page_list{
    margin-right: 10px;
    margin-left: 10px;
}
.photo_book_page_list_group{

}
.photo_book_page_list_group_item{

/*
background-color: #fff;
border: 1px solid #e9ecef;
*/
background-color: rgba(76, 175, 80, 0.0);
border: 0px;
/*
margin: 12px;
padding: 10px;
*/
padding: 10px;
/*
height: 100px;
*/
}
</style>